export function getCountry(city) {
  var country = city.toLowerCase();

  /*------VENUES------*/

  if (country.includes("diriyya")) { return "sa"; }
  else if (country.includes("diriyah")) { return "sa"; }
  else if (country.includes("jeddah")) { return "sa"; }
  else if (country.includes("marrakesch")) { return "ma"; }
  else if (country.includes("marrakesh")) { return "ma"; }
  else if (country.includes("marrakech")) { return "ma"; }
  else if (country.includes("santiago")) { return "cl"; }
  else if (country.includes("mexico")) { return "mx"; }
  else if (country.includes("hong")) { return "hk"; }
  else if (country.includes("sanya")) { return "cn"; }
  else if (country.includes("rom")) { return "it"; }
  else if (country.includes("misano")) { return "it"; }
  else if (country.includes("paris")) { return "fr"; }
  else if (country.includes("monaco")) { return "mc"; }
  else if (country.includes("berlin")) { return "de"; }
  else if (country.includes("bern")) { return "ch"; }
  else if (country.includes("swiss")) { return "ch"; }
  else if (country.includes("york")) { return "us"; }
  else if (country.includes("seoul")) { return "sk"; }
  else if (country.includes("london")) { return "uk"; }
  else if (country.includes("jakarta")) { return "id"; }
  else if (country.includes("hyderabad")) { return "in"; }
  else if (country.includes("portland")) { return "us"; }
  else if (country.includes("miami")) { return "us"; }
  else if (country.includes("sao")) { return "br"; }
  else if (country.includes("tokio")) { return "jp"; }
  else if (country.includes("tokyo")) { return "jp"; }
  else if (country.includes("shanghai")) { return "cn"; }
  else if (country.includes("schanghai")) { return "cn"; }
  else if (country.includes("valencia")) { return "es"; }
  else if (country.includes("puebla")) { return "mx"; }
  else if (country.includes("buenos")) { return "ar"; }
  else if (country.includes("vancouver")) { return "ca"; }
  else if (country.includes("madrid")) { return "es"; }
  else if (country.includes("eindhoven")) { return "nl"; }
  else if (country.includes("kapstadt")) { return "za"; }
  else if (country.includes("cape town")) { return "za"; }
  else if (country.includes("desert")) { return "sa"; }
  else if (country.includes("ocean")) { return "sg"; }
  else if (country.includes("arctic")) { return "gr"; }
  else if (country.includes("amazon")) { return "br"; }
  else if (country.includes("glacier")) { return "ar"; }
}